import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

function ConcernedAboutRevealingModal({ isOpen = false, toggle = () => {} }) {
  return (
    <Modal show={isOpen} onHide={toggle} size="lg" backdrop="static" keyboard>
      <Modal.Header closeButton>
        <Modal.Title className="fw-semibold">Concerned about revealing your story idea?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-4">
          You can source expert commentary without revealing details about your story. Instead of describing your angle,
          emphasize the type of expertise you need.
        </p>

        <div className="mb-4">
          <p className="text-secondary fw-semibold mb-2">For example, instead of mentioning your interview topic:</p>
          <div
            className="p-3 bg-light rounded border-start border-warning border-4 mb-3"
            style={{ borderColor: '#FFC107 !important' }}
          >
            <p className="mb-0 text-warning" style={{ fontSize: '16px' }}>
              &ldquo;Epidemiology expert needed for an interview on pandemic preparedness.&rdquo;
            </p>
          </div>

          <p className="text-secondary fw-semibold mb-2">Focus on the experts you&apos;d like to interview:</p>
          <div
            className="p-3 bg-light rounded border-start border-success border-4"
            style={{ borderColor: '#198754 !important' }}
          >
            <p className="mb-0 text-success" style={{ fontSize: '16px' }}>
              &ldquo;Seeking an epidemiology or public health expert.&rdquo;
            </p>
          </div>
        </div>

        <p>
          If you prefer even more discretion, check the box at the bottom of the form that tells us not to promote your
          request outside of the Qwoted platform.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-primary" onClick={toggle}>
          Got it
        </button>
      </Modal.Footer>
    </Modal>
  );
}

ConcernedAboutRevealingModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
};

ConcernedAboutRevealingModal.defaultProps = {
  isOpen: false,
  toggle: () => {},
};

export default ConcernedAboutRevealingModal;
